<template>
  <div>
    <action-bar>
      <router-link :to="{name: 'key-theme-create'}">Themenschwerpunkt erstellen</router-link>
    </action-bar>
    <main class="content">
      <h1>Themenschwerpunkte</h1>
      <table class="table table-striped" v-if="keyThemes">
        <thead>
          <tr>
            <th>Titel</th>
            <th class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="keyTheme in keyThemes" :key="keyTheme.id">
            <td>{{keyTheme.name.text}}</td>
            <td class="text-right">
              <a
                href="#"
                v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, keyTheme),
                            message: 'Bist du sicher, dass du den Themenschwerpunkt <strong>'+keyTheme.name.text+'</strong> löschen möchtest?'}"
              >
                <i class="fa fa-trash"></i>
              </a>
              <router-link :to="{ name: 'key-theme-edit', params: { keyThemeId: keyTheme.id }}">
                <i class="fa fa-edit fa-fw"></i>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
      <loading v-else></loading>
    </main>
  </div>
</template>
<script>
export default {
  asyncComputed: {
    async keyThemes() {
      const {
        data: { result: keyThemes }
      } = await axios.get("/api/" + store.state.language + "/key_theme/list");

      return keyThemes.sort((a, b) => a.synthesisPosition - b.synthesisPosition);
    }
  },
  methods: {
    remove(dialog, keyTheme) {
      this.keyThemes.splice(this.keyThemes.indexOf(keyTheme), 1);
      axios.post(
        "/api/" + store.state.language + "/key_theme/" + keyTheme.id + "/delete"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/key_theme/List.vue